// TODO : Description Jadiin 2
// TODO : Still HARDCODE Transaction Type
<style>
    .large-popup .vs-popup {
        width: 1000px;
    }
</style>
<template>
    <div v-if="ready">
        <vs-card class="p-4">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Stock Transfer Details</h4>
                </div>
                <div class="flex items-center">
                <vs-button
                    color="primary"
                    class="btn mb-4 md:mb-0 mr-1" @click="saveUpdate">Save</vs-button>
                <vs-dropdown vs-trigger-click>
                    <vs-button class="btn mb-4 md:mb-0 mr-1">Process</vs-button>
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="pickMovement"> Pick Movement </vs-dropdown-item>
                        <vs-dropdown-item @click="putMovement"> Put Movement </vs-dropdown-item>
                        <vs-dropdown-item divider @click="confirmMovement"> Confirm Movement </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Transfer ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.stock_transfer.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.stock_transfer.reference" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Posting Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.stock_transfer.posting_date" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Transaction Type*
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                                <vs-input
                                    class="w-full"
                                    v-model="data.stock_transfer.type"
                                    disabled
                                />
                                <template slot="append">
                                    <div class="append-text btn-addon">
                                        <vs-button
                                            size="small"
                                            color="primary"
                                            icon-pack="feather"
                                            icon="icon-search"
                                            disabled
                                        ></vs-button>
                                    </div>
                                </template>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" disabled v-model="data.stock_transfer.description"/>
                        </div>
                    </div>
                     <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                                Attachment
                            </div>
                            <div class="vx-col w-2/3">
                               <input type="file" id="file_name" v-on:change="handleFileUpload($event)"/>
                            </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-5">
                <vs-tab label="Item Details" class="pt-base">
                    <vs-table :data="data.stock_transfer_details" hoverFlat class="mt-base">
                        <template slot="thead">
                            <vs-th>Line ID</vs-th>
                            <vs-th>Line Type</vs-th>
                            <vs-th>Warehouse ID</vs-th>
                            <vs-th>Client ID</vs-th>
                            <vs-th>Product ID</vs-th>
                            <vs-th>Description</vs-th>
                            <vs-th>Pack ID</vs-th>
                            <vs-th>Batch</vs-th>
                            <vs-th>Exp. Date</vs-th>
                            <vs-th>Base Qty</vs-th>
                            <vs-th>Base UoM</vs-th>
                            <vs-th>Stock Type</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>{{ tr.line_id }}</vs-td>
                                <vs-td>{{ tr.line_type }}</vs-td>
                                <vs-td>{{ tr.warehouses_code }}</vs-td>
                                <vs-td>{{ tr.client_code }}</vs-td>
                                <vs-td>{{ tr.product_code }}</vs-td>
                                <vs-td style="max-width: 200px; text-overflow: ellipsis; overflow: hidden;">{{ tr.description_1 }}</vs-td>
                                <vs-td>{{ tr.pack_id }}</vs-td>
                                <vs-td>{{ tr.batch }}</vs-td>
                                <vs-td>{{ tr.expired_date }}</vs-td>
                                <vs-td>{{ tr.base_qty }}</vs-td>
                                <vs-td>{{ tr.base_uom_name }}</vs-td>
                                <vs-td>{{ tr.stock_type_name }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
                <vs-tab label="Notes" class="pt-base">
                    <vs-textarea label="Note" height="200" v-model="data.note" :disabled="!editMode"/>
                </vs-tab>
                <vs-tab label="Attachment">
                        <vs-table :data="attachments">
                            <template slot="thead">
                                <vs-th>No.</vs-th>
                                <vs-th>File Name</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="indextr">
                                    {{ indextr + 1 }}
                                </vs-td>
                                <vs-td :data="data[indextr].file_name">
                                    {{ data[indextr].file_name }}
                                </vs-td>
                                <vs-td :data="indextr">
                                    <vs-button color="success" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Download</vs-button>
                                    <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)" :disabled="editMode ? false : true">Remove</vs-button>
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
            </vs-tabs>
        </vs-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            data: {},
            editMode: false,
            ready: false
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        back() {
            this.$router.push({name: 'stock-transfer'})
        },
        fetchData() {
            this.isLoading = true
            this.$http.get('inventories/stocktransfer/show/' + this.$route.params.id)
            .then(res => {
                this.isLoading = false
                this.data = res.data
                this.ready = true
            })
            .catch(error => this.handleError(error))
        },
        putMovement() {
            this.isLoading = true
            this.$http.post('inventories/stocktransfer/process/put', { id: this.$route.params.id })
            .then(res => {
                setTimeout(() => {
                    this.$router.push({ name: 'stock-transfer-put', params: { data: res.data, id: this.$route.params.id} })
                }, 300)
            })
            .catch(error => this.handleError(error))
        },
        handleFileUpload(event){
            this.file = event.target.files[0];
            },
        saveUpdate(){
            this.isLoading = true
             let document_send = {
                module_id:this.$route.params.id,
                module_name:'transfer'
            };
            let file = new FormData();
            file.append("file_name",this.file);
            this.$http.post('/attachment/uploads',file,{
              headers: {
                  "Content-Type": "multipart/form-data"
              },
              params: document_send
            })
            .then((resp) => {
                // this.$router.replace('/inbound-delivery');
                // this.on_edit = false;
                this.isLoading = false
                this.$vs.notify({
                color: 'success',
                title: 'Update Success',
                text: 'Update Attachment Succesfully'
                });
                
               
            })
            .catch((error) =>{
                this.isLoading = false               
            });
        },
        pickMovement() {
            this.isLoading = true
            this.$http.post('inventories/stocktransfer/process/pick', { id: this.$route.params.id })
            .then(res => {
                setTimeout(() => {
                    this.$router.push({ name: 'stock-transfer-pick', params: { data: res.data, id: this.$route.params.id} })
                }, 300)
            })
            .catch(error => this.handleError(error))
        },
        confirmMovement() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: 'Confirmation',
                text: 'Confirm movement orders?',
                accept: () => {
                    this.isLoading = true
                    const data = {
                        transaction_source: this.$route.params.id,
                        transaction_types: ['ST']
                    }

                    this.confirmAll(data)
                    .then(res => {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: res.data.message || "Success confirm"
                        });

                        this.fetchData()
                    })
                    .catch(error => this.handleError(error))
                },
                acceptText: 'Yes',
                cancelText: 'No'
            })
        }
    },
    mounted() {
        this.fetchData()
        this.$http.get('attachment/'+this.$route.params.id).then((res) => {
            this.attachments = res.data.result
        });
    }
};
</script>